export default __webpack_public_path__ + "static/NeueMontreal-Bold-338c3fd125171a486ed0eaaa324c062e.eot";